import { useCallback, useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

type Props = {
  defaultSelection?: 'rootStart' | 'rootEnd';
  mode?: 'auto' | 'manual';
  onFocusEditor?: (focus: () => void) => void;
};

export const AutoFocusPlugin = ({
  defaultSelection,
  mode = 'manual',
  onFocusEditor,
}: Props): null => {
  const [editor] = useLexicalComposerContext();

  const handleFocus = useCallback(
    () =>
      editor.focus(
        () => {
          const activeElement = document.activeElement;
          const rootElement = editor.getRootElement() as HTMLDivElement;
          if (
            rootElement !== null &&
            (activeElement === null || !rootElement.contains(activeElement))
          ) {
            rootElement.focus({ preventScroll: true });
          }
        },
        { defaultSelection },
      ),
    [defaultSelection, editor],
  );

  useEffect(() => {
    if (mode === 'manual' && onFocusEditor) {
      onFocusEditor(() => handleFocus());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor]);

  useEffect(() => {
    if (mode === 'auto') {
      handleFocus();
    }
  }, [defaultSelection, editor, mode, handleFocus]);

  return null;
};
